import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiKeysService } from '../services';

/**
 * Hook para excluir uma API Key
 *
 * IMPORTANTE: Ação irreversível. Sempre confirmar com usuário antes de executar.
 *
 * @example
 * const { mutate: deleteKey, isPending } = useDeleteApiKey();
 *
 * const handleDelete = () => {
 *   if (confirm('Tem certeza que deseja excluir esta API Key?')) {
 *     deleteKey(keyId);
 *   }
 * };
 */
export const useDeleteApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ApiKeysService.deleteApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};
